import { Grid, Paper } from "@mui/material";
import React from "react";
import MainMenu from "../../components/MainMenu";
import NewList from "../../components/NewManagmentComponent/NewList";

const index = () => {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <NewList />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default index;
